import React from 'react';
import { observer } from 'mobx-react';
import { DefaultPageViewModel } from '../default-page.viewmodel';
import { SORT_ORGANIZATION_BY } from '../../../../../../../../modules/passport-pages/config';
import { FormField } from '../../../../../../../global/form/form-field/form-field';
import { useIntl } from 'react-intl';
import { InfoPopover } from '../../../../../../../global/info-popover/info-popover';
import { OERadioOptions } from '../../../../../../../global/oe-radio-options/oe-radio-options';
import { SortOrganizationsByOptions } from '../../../../../../../../api/custom-pages.dao';

type Props = {
    pageVm: DefaultPageViewModel;
};

export const SpeakersPageFields = observer(({ pageVm }: Props): JSX.Element => {
    const { formatMessage } = useIntl();
    const sortOrganizationByEntity = pageVm.getFieldConfigByKey(SORT_ORGANIZATION_BY);
    const sortOrganizationByLabelText = formatMessage(sortOrganizationByEntity.labelDescriptor);
    const sortOrganizationBy = pageVm.getFieldByKey(SORT_ORGANIZATION_BY);
    const setSortOrganizationBy = (value: string) => pageVm.setFieldValueByKey(SORT_ORGANIZATION_BY, value);

    return (
        <FormField
            label={
                <div className='flex m-bottom-6px'>
                    {sortOrganizationByLabelText}
                    <InfoPopover className='m-left-8px'>
                        {sortOrganizationByEntity?.toggleInfoMessage}
                    </InfoPopover>
                </div>
            }
            className='speakers-page-sort-organization-by'
        >
            <OERadioOptions
                width='fit-content'
                options={[
                    {
                        label: formatMessage({
                            id: 'oe.defaultPage.alphabeticalOrder',
                            description: 'Label text',
                            defaultMessage: 'Alphabetical Order'
                        }),
                        value: SortOrganizationsByOptions.ALPHABETICAL_ORDER
                    },
                    {
                        label: formatMessage({
                            id: 'oe.defaultPage.priorityInEvent',
                            description: 'Label text',
                            defaultMessage: 'Priority in Event'
                        }),
                        value: SortOrganizationsByOptions.PRIORITY_IN_EVENT
                    },
                ]}
                value={sortOrganizationBy.value as string}
                onOptionToggle={setSortOrganizationBy}
            />
        </FormField>
    );
});
